export default {
	login (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/cgt_manage/login', params)
	},
	logout (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/cgt_manage/logout', params)
	},
	check (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/cgt_manage/check', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/CgtManageAuth.js